import { Box, Typography } from "@mui/material";
import CustomIcon from "components/CustomIcon";

const InputErrorMessage = ({ message, icon }: { message: string | JSX.Element[] | null; icon?: JSX.Element }) => {
    return (
        <Box display="flex" alignItems="center">
            {icon && (
                <CustomIcon
                    sx={{
                        color: "error.main",
                        fontSize: "14px",
                        marginRight: "8px",
                    }}
                    icon={icon}
                />
            )}

            <Typography sx={{ fontSize: "10px" }}>{message}</Typography>
        </Box>
    );
};

export default InputErrorMessage;
